import React, { useCallback, useContext } from 'react';
import { inject, observer } from 'mobx-react';
import RootStore from 'store';
import { LoadingStatus, UserRoles } from 'enums';
import { ToastContext } from 'App';
import PushNotificationsForm from 'components/push-notifications/PushNotificationsForm';
import userStore from 'store/UserStore';
import { Message } from 'primereact/message';

const PushNotificationsPageComponent: React.FC<{
  rootStore?: typeof RootStore;
}> = ({ rootStore }) => {
  const { pushNotificationsStore } = rootStore!;
  const toast = useContext(ToastContext);
  const isReadOnly = userStore.role === UserRoles.SUPPORT;

  const handleSendNotification = useCallback(
    (title: string, description: string) =>
      pushNotificationsStore.sendPushNotification(title, description, toast),
    [pushNotificationsStore, toast],
  );

  return (
    <div>
      <h1>Push-уведомления</h1>
      {isReadOnly && (
        <Message
          severity="info"
          text="Доступно только для чтения"
          style={{ marginBottom: '1rem', width: '100%' }}
        />
      )}
      <PushNotificationsForm
        sendPushNotification={handleSendNotification}
        isLoading={pushNotificationsStore.status === LoadingStatus.PENDING}
        isReadOnly={isReadOnly}
      />
    </div>
  );
};

const PushNotificationsPage = inject('rootStore')(
  observer(PushNotificationsPageComponent),
);
export { PushNotificationsPage };
